
import { useState } from 'react';
import { Link, useNavigate } from 'react-router';
import { DropdownMenu } from 'radix-ui';
import { CircleUserRound, ChevronDown, ChevronRight, Settings2, LogOut } from 'lucide-react';

import { logout } from '../../services/auth.js';

export default function AccountMenu() {
	const navigate = useNavigate();

	const [loggingOut, setLoggingOut] = useState(false);
	const [logoutError, setLogoutError] = useState('');

	async function handleLogout() {
		if (loggingOut) return;

		setLoggingOut(true);
		setLogoutError('');

		try {
			await logout();
			navigate('/login', { replace: true });
		}
		catch (error) {
			console.error('Logout error:', error);
			setLogoutError('Deconectarea a eșuat. Încearcă din nou.');
			setLoggingOut(false);
		}
	}

	return (
		<DropdownMenu.Root modal={false}>
			<DropdownMenu.Trigger asChild>
				<button type="button" aria-label="Meniu cont" className="group flex min-h-11 items-center gap-2.5 rounded-xl px-1.5 text-left outline-none transition-colors hover:bg-zinc-100 focus-visible:ring-2 focus-visible:ring-brand-500 data-[state=open]:bg-zinc-100 dark:hover:bg-white/[0.07] dark:data-[state=open]:bg-white/[0.07] sm:px-2">
					<span className="flex size-9 shrink-0 items-center justify-center rounded-full bg-brand-500/15 text-[#8b6500] ring-1 ring-brand-500/20 dark:text-brand-400">
						<CircleUserRound size={21} strokeWidth={1.7} />
					</span>

					<span className="hidden text-left sm:block">
						<span className="block text-sm font-semibold leading-5 text-zinc-900 dark:text-white">
							Cont
						</span>
						<span className="block text-xs text-zinc-600 dark:text-zinc-400">
							Administrator
						</span>
					</span>

					<ChevronDown size={15} className="hidden text-zinc-500 transition-transform group-data-[state=open]:rotate-180 dark:text-zinc-400 sm:block" />
				</button>
			</DropdownMenu.Trigger>

			<DropdownMenu.Portal>
				<DropdownMenu.Content align="end" sideOffset={12} collisionPadding={12} className="z-50 w-64 rounded-2xl border border-zinc-200 bg-white p-1.5 text-zinc-900 shadow-xl shadow-black/10 outline-none dark:border-white/10 dark:bg-[#191a1f] dark:text-white dark:shadow-black/40">
					<DropdownMenu.Label className="px-3 py-3">
						<div className="text-sm font-semibold">Cont administrator</div>
						<div className="mt-1 text-xs font-normal text-zinc-600 dark:text-zinc-400">
							Preferințe și sesiune
						</div>
					</DropdownMenu.Label>

					<DropdownMenu.Separator className="my-1 h-px bg-zinc-200 dark:bg-white/10" />

					<DropdownMenu.Item asChild>
						<Link to="/settings/general" className="flex min-h-11 cursor-pointer items-center gap-3 rounded-xl px-3 text-sm font-medium outline-none transition-colors data-[highlighted]:bg-zinc-100 dark:data-[highlighted]:bg-white/[0.07]">
							<Settings2 size={18} strokeWidth={1.8} className="text-zinc-600 dark:text-zinc-400" />
							<span className="flex-1">Setări</span>
							<ChevronRight size={15} className="text-zinc-500" />
						</Link>
					</DropdownMenu.Item>

					<DropdownMenu.Separator className="my-1 h-px bg-zinc-200 dark:bg-white/10" />

					<DropdownMenu.Item disabled={loggingOut} onSelect={event => {
						event.preventDefault();
						void handleLogout();
					}} className="flex min-h-11 cursor-pointer items-center gap-3 rounded-xl px-3 text-sm font-medium text-red-600 outline-none transition-colors data-[highlighted]:bg-red-50 data-[disabled]:cursor-wait data-[disabled]:opacity-50 dark:text-red-400 dark:data-[highlighted]:bg-red-500/10">
						<LogOut size={18} strokeWidth={1.8} />
						<span>{loggingOut ? 'Se deconectează...' : 'Deconectare'}</span>
					</DropdownMenu.Item>

					{logoutError && (
						<p role="alert" className="px-3 py-2 text-xs text-red-600 dark:text-red-400">
							{logoutError}
						</p>
					)}
				</DropdownMenu.Content>
			</DropdownMenu.Portal>
		</DropdownMenu.Root>
	);
}